import { render, staticRenderFns } from "./EditPost.vue?vue&type=template&id=6d1bc9aa&scoped=true&"
import script from "./EditPost.vue?vue&type=script&lang=js&"
export * from "./EditPost.vue?vue&type=script&lang=js&"
import style0 from "./EditPost.vue?vue&type=style&index=0&id=6d1bc9aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1bc9aa",
  null
  
)

export default component.exports